import { apiClient } from '@/lib/api/apiClient';

export interface CategoryDto {
  id: string;
  name: string;
  description?: string;
  imageUrl?: string;
  displayOrder: number;
  questionCount: number;
  /** تفعيل للمستخدمين الجدد - تظهر الفئة ملونة في التجربة المجانية حتى لو كان القسم غير مجاني */
  enableForNewUsers?: boolean;
}

export interface SectionWithCategoriesDto {
  id: string;
  name: string;
  description?: string;
  imageUrl?: string;
  displayOrder: number;
  categories: CategoryDto[];
}

const SECTIONS_ENDPOINT = '/api/sections';

export const playerSectionService = {
  /**
   * Get all enabled sections with their categories (for players)
   */
  async getSectionsWithCategories(): Promise<SectionWithCategoriesDto[]> {
    try {
      const response = await apiClient.get(SECTIONS_ENDPOINT);
      return response.data.data || [];
    } catch (error) {
      console.error('Failed to fetch sections:', error);
      return getDefaultSections();
    }
  },
};

/**
 * Default sections as fallback
 */
function getDefaultSections(): SectionWithCategoriesDto[] {
  const basePath = '/Resources/Sections/General Section/Catgeories';
  return [
    {
      id: 'general',
      name: 'القسم العام',
      description: 'أسئلة متنوعة في مختلف المجالات',
      imageUrl: `${basePath}/معلومات عامة.jpeg`,
      displayOrder: 1,
      categories: [
        { id: '1', name: 'أعلام الدول', description: 'اختبر معلوماتك في أعلام دول العالم', imageUrl: `${basePath}/أعلام الدول.jpeg`, displayOrder: 1, questionCount: 50, enableForNewUsers: true },
        { id: '2', name: 'الجواب كلمتين', description: 'الإجابة تتكون من كلمتين', imageUrl: `${basePath}/الجواب كلمتين.jpeg`, displayOrder: 2, questionCount: 30, enableForNewUsers: true },
        { id: '3', name: 'تاريخ', description: 'أسئلة عن التاريخ العربي والعالمي', imageUrl: `${basePath}/تاريخ.jpeg`, displayOrder: 3, questionCount: 100, enableForNewUsers: true },
        { id: '4', name: 'جغرافيا', description: 'أسئلة عن الجغرافيا والمدن والبلدان', imageUrl: `${basePath}/جغرافيا.jpeg`, displayOrder: 4, questionCount: 80, enableForNewUsers: true },
        { id: '5', name: 'حروف', description: 'أسئلة تتعلق بالحروف والكلمات', imageUrl: `${basePath}/حروف.jpeg`, displayOrder: 5, questionCount: 40, enableForNewUsers: true },
        { id: '6', name: 'رتب الأحداث', description: 'رتب الأحداث التاريخية بالترتيب الصحيح', imageUrl: `${basePath}/رتب الاحداث.jpeg`, displayOrder: 6, questionCount: 35, enableForNewUsers: true },
        { id: '7', name: 'صحح الخطأ', description: 'اكتشف الخطأ وصححه', imageUrl: `${basePath}/صحح الخطأ.jpeg`, displayOrder: 7, questionCount: 40, enableForNewUsers: true },
        { id: '8', name: 'عالم الحيوان', description: 'أسئلة عن الحيوانات والطيور', imageUrl: `${basePath}/عالم الحيوان.jpeg`, displayOrder: 8, questionCount: 70, enableForNewUsers: true },
        { id: '9', name: 'عالم الطب', description: 'أسئلة طبية وصحية', imageUrl: `${basePath}/عالم الطب.jpeg`, displayOrder: 9, questionCount: 30, enableForNewUsers: true },
        { id: '10', name: 'عواصم وعملات', description: 'أسئلة عن عواصم الدول وعملاتها', imageUrl: `${basePath}/عواصم وعملات.jpeg`, displayOrder: 10, questionCount: 60, enableForNewUsers: true },
        { id: '11', name: 'لغات ولهجات', description: 'أسئلة عن اللغات واللهجات المختلفة', imageUrl: `${basePath}/لغات ولهجات.jpeg`, displayOrder: 11, questionCount: 45, enableForNewUsers: true },
        { id: '12', name: 'لغة وأدب', description: 'أسئلة في اللغة العربية والأدب', imageUrl: `${basePath}/لغة وأدب.jpeg`, displayOrder: 12, questionCount: 60, enableForNewUsers: true },
        { id: '13', name: 'معلومات عامة', description: 'أسئلة ثقافية متنوعة', imageUrl: `${basePath}/معلومات عامة.jpeg`, displayOrder: 13, questionCount: 120, enableForNewUsers: true },
        { id: '14', name: 'من القائل', description: 'اكتشف من قال هذه المقولة', imageUrl: `${basePath}/من القائل.jpeg`, displayOrder: 14, questionCount: 50, enableForNewUsers: true },
      ],
    },
  ];
}
